import React from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useMediaQuery } from "@mui/material";

import { useLanguage } from "../context/LanguageContext.js";

const BoutonAddPeriod = ({ label, onClick, disabled = false }) => {
  const { t } = useLanguage();
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Button
      variant="outlined"
      size="small"
      onClick={onClick}
      startIcon={<AddIcon sx={{ fontSize: isMobile ? "0.7rem" : "0.8rem", color: "#fff"  }} />}
      disabled={disabled}
      sx={{
        minWidth: "auto",        // supprime la largeur minimale imposée par MUI
        minHeight: "auto",       // supprime la hauteur imposée
        textTransform: "none",      // 🔑 pas de majuscules forcées
        lineHeight: 1,          // 🔑 réduit la hauteur de ligne
        display: "flex",
        flexDirection: "row", // icône + texte alignés
        alignItems: "center",
        gap: 0.3,
        color: "#fff",    
        backgroundColor: "#3399FF !important",          // texte
        borderColor: "#3399FF",        // bordure    
        marginLeft: 1,
        marginTop: 1,
        fontWeight: "bold",
        fontSize: isMobile ? "0.55rem" : "0.65rem", // 🔑 texte minuscule mais lisible
        padding: isMobile ? "1px 4px" : "2px 6px",  // 🔑 padding réduit
        borderRadius: "4px",
        transition: "all 0.3s ease",
        '&:hover': {
          backgroundColor: "#3399FF",  // fond au survol
          color: "#fff",               // texte au survol
          }, 
      }}
    >
      {/* 👉 Sur mobile : pas de texte, uniquement l’icône */}
      {!isMobile && t("AddPeriod")}
    </Button>
  );
};

export default BoutonAddPeriod;
